import { useThemeStore } from "shared-lib";
import { Button, Switch } from "antd";

export default function ThemeToggle({ collapsed }: { collapsed: boolean }) {
  const themeState = useThemeStore();

  function toggleTheme() {
    const newTheme = themeState.theme === "dark" ? "light" : "dark";
    document.documentElement.classList.toggle("dark", newTheme === "dark");
    themeState.setTheme(newTheme);
  }
  if (collapsed) {
    return (
      <Button onClick={() => toggleTheme()} type="text">
        {themeState.theme === "dark" ? "🌞" : "🌙"}
      </Button>
    );
  }
  return (
    <Switch
      checked={themeState.theme === "dark"}
      onChange={() => toggleTheme()}
      checkedChildren="🌙 "
      unCheckedChildren="🌞 "
    ></Switch>
  );
}
